import { create } from "zustand"

export const useTestsStore = create((set) => ({
    // tests: [
    //     {
    //         id: 1,
    //         first_name: "Иван",
    //         last_name: "Иванов",
    //         date: "2024-09-01T12:30",
    //         subject: "Русский язык",
    //         status_id: 2,
    //         link: 'https://youtube.com/',
    //         note: 'примечания 1'
    //     },
    //     {
    //         id: 2,
    //         first_name: "Никита",
    //         last_name: "Овчинников",
    //         date: "2024-09-03T10:30",
    //         subject: "Математика",
    //         status_id: 1,
    //         link: 'https://youtube.com/',
    //         note: 'примечания 2'
    //     },
    //     {
    //         id: 3,
    //         first_name: "Иван",
    //         last_name: "Овчинников",
    //         date: "2024-09-07T15:00",
    //         subject: "Физика",
    //         status_id: 2,
    //         link: 'https://youtube.com/',
    //         note: 'примечания 3'
    //     },
    // ],
    tests: [],
    setTests: (newTests) => set({ tests: newTests }),
}))
